
<template>

    <div :class=" ModalClasses ">

        <div class="modal-inner-wrapper">

            <div class="close-wrapper">

                <font-awesome-icon class="icon-class" id="settings-icon" icon="times" @click=" toggleModal() "></font-awesome-icon>
            </div>

            <component v-if=" modalComponent != null " :is=" modalComponent " />
        </div>
    </div>

</template>


<script>

    import { mapGetters, mapActions } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import ConfirmOrder from './modalViews/ConfirmOrder';


    export default {
        name: 'modal',
        methods: {

            ...mapActions({

                toggleModal : 'modal/toggleModal',
            })
        },
        computed: {

            ...mapGetters({

                modalOpen      : 'modal/modalShowing',
                modalComponent : 'modal/modalComponent',
            }),
            ModalClasses(){

                let classes = [];
                classes.push( "modal-outer-wrapper" );
                classes.push( ( this.modalOpen ) ? 'open' : 'closed' );
                classes.join( " " );
                return classes;
            },
        },
        components: {

            FontAwesomeIcon,
            ConfirmOrder
        }
    }

</script>

<style scoped>

    .modal-outer-wrapper{

        background-color: transparent;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: fixed;
        z-index: 775;
        transition: all 0.5s;
        width: 95%;
        left: 2%; right: 2%;
    }

    .modal-inner-wrapper{

        background-color: #f5f5f5;
        width: 100%;
        height: 100%;
        padding: 15px 15px 35px;
        box-sizing: border-box;
        z-index: 785;
        border-radius: 10px;
    }
    .close-wrapper{

        width: 100%;
        display: flex;
        box-sizing: border-box;
        justify-content: flex-end;
        padding: 0 15px;
        cursor: pointer;
    }
    .open{

        top: 2%;
    }
    .closed{

        top: 105%;
    }
</style>